import React from 'react';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type FlowStep = {
  icon?: React.ReactNode;
  label: string;
  sub?: string;
};

type Props = {
  steps: FlowStep[];
};

/**
 * 横方向のステップフロー（矢印付き）
 */
const WorkflowHorizontalFlow: React.FC<Props> = ({ steps }) => {
  return (
    <Stack direction="row" alignItems="center" sx={{ overflowX: 'auto', py: 1.5, gap: 0.5 }}>
      {steps.map((step, index) => (
        <React.Fragment key={index}>
          <Box
            sx={{
              border: 1,
              borderColor: 'divider',
              borderRadius: 2,
              px: 2,
              py: 1.5,
              minWidth: 120,
              textAlign: 'center',
              bgcolor: 'action.hover',
              flexShrink: 0,
            }}
          >
            {step.icon && <Box sx={{ mb: 0.5, color: 'primary.main' }}>{step.icon}</Box>}
            <Typography variant="body2" fontWeight={600}>
              {step.label}
            </Typography>
            {step.sub && (
              <Typography variant="caption" color="text.secondary">
                {step.sub}
              </Typography>
            )}
          </Box>
          {index < steps.length - 1 && (
            <ArrowForwardIcon sx={{ fontSize: 20, color: 'text.disabled', flexShrink: 0 }} />
          )}
        </React.Fragment>
      ))}
    </Stack>
  );
};

export default WorkflowHorizontalFlow;
